import React, { useState } from 'react';
import ReactDOM from 'react-dom';

// Inherit all standard image props (src, alt, style, className, etc.)
interface ZoomableImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallbackSrc?: string;
}

const ZoomableImage: React.FC<ZoomableImageProps> = ({ fallbackSrc, style, onClick, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Styles for the modal
    const overlayStyle: React.CSSProperties = {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        cursor: 'zoom-out'
    };

    const modalImageStyle: React.CSSProperties = {
        maxWidth: '90vw',
        maxHeight: '90vh',
        objectFit: 'contain',
        borderRadius: '8px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        cursor: 'default'
    };

    const handleImageClick = (e: React.MouseEvent<HTMLImageElement>) => {
        setIsOpen(true);
        if (onClick) onClick(e); // Preserve any onClick passed from parent
    };

    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        if (fallbackSrc) {
            e.currentTarget.src = fallbackSrc;
        }
    };

    return (
        <>
            {/* The base image displayed on the page */}
            <img 
                {...props} 
                onClick={handleImageClick}
                onError={handleError}
                style={{ ...style, cursor: 'zoom-in' }} 
            />

            {/* The Portal that renders the modal at the document root */}
            {isOpen && ReactDOM.createPortal(
                <div style={overlayStyle} onClick={() => setIsOpen(false)}>
                    <img 
                        src={props.src} 
                        alt={props.alt || 'Enlarged view'} 
                        style={modalImageStyle} 
                        onClick={(e) => e.stopPropagation()} 
                    />
                </div>,
                document.body
            )}
        </>
    );
};

export default ZoomableImage;